/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const bulkPartialPatchDependencyPairSchema = z.object({
  itemId: z.int(),
  targetItemId: z.int(),
});
